import { styled } from "goober";
import { Card } from "../Settings/shared";
import { Text } from "../Text";
import { Toggle } from "../Toggle";

const Row = styled("div")`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 8px;
`;

const Info = styled("div")`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

type Props = {
  enabled: boolean;
  required: boolean;
  disabled: boolean;
  onToggle: () => void;
  onToggleRequired: () => void;
};

export function AvailabilityCard({
  enabled,
  required,
  disabled,
  onToggle,
  onToggleRequired,
}: Props) {
  return (
    <Card>
      <Row>
        <Info>
          <Text variant="text-regular-md">Available to AI</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            3B can use this skill when needed.
          </Text>
        </Info>
        <Toggle isOn={enabled} disabled={disabled} onToggle={onToggle} />
      </Row>
      <Row>
        <Info>
          <Text variant="text-regular-md">Required skill</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            3B must follow this skill in every workflow chat where it’s
            available.
          </Text>
        </Info>
        <Toggle
          isOn={required}
          disabled={disabled || !enabled}
          onToggle={onToggleRequired}
        />
      </Row>
    </Card>
  );
}
